var _rect, _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTatvaAiDdx(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 72,
    height: 73,
    viewBox: "0 0 72 73",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 72,
    height: 72,
    rx: 17.1429,
    transform: "matrix(-1 0 0 1 72 0.5)",
    fill: "#22003C"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M60.0713 53.1278C45.0165 53.1278 30.9474 59.1187 25.7947 62.1142C21.6498 64.1683 20.0352 61.2584 19.746 59.5466C19.746 45.1683 13.4731 31.7313 10.3366 26.8101C8.72361 23.7291 11.0087 21.675 12.3529 21.0331C30.6338 20.0061 42.821 14.1863 46.6295 11.4048C51.4686 9.86423 53.1264 12.9025 53.3504 14.6142C53.8881 28.4791 60.2953 42.6435 63.4318 47.9926C65.0448 51.5872 61.8635 52.9138 60.0713 53.1278Z",
    stroke: "#9870FF",
    strokeOpacity: 0.4,
    strokeWidth: 2.6
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M39.935 63.8323C30.3109 53.4189 16.9781 47.6973 11.5147 46.1382C7.37733 44.646 8.45269 41.5815 9.50754 40.2357C19.921 30.6116 25.6425 17.2787 27.2016 11.8153C28.4019 8.63728 31.3503 8.84303 32.6745 9.34316C45.1047 21.3006 57.1105 25.8351 61.5597 26.6077C65.7688 28.9237 64.6282 32.1041 63.5317 33.4048C53.8339 43.057 47.6713 56.9698 45.8023 62.7196C44.2301 66.2413 41.2356 64.9288 39.935 63.8323Z",
    stroke: "#9870FF",
    strokeOpacity: 0.4,
    strokeWidth: 2.6
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M46 34.417C46 34.417 46 34.417 46 34.417C46 31.1448 43.3137 28.4922 40 28.4922C38.4633 28.4922 37.0615 29.0627 36 30.0008C34.9385 29.0627 33.5367 28.4922 32 28.4922C28.6863 28.4922 26 31.1448 26 34.417C26 34.417 26 34.417 26 34.4171C26 41.676 32.6715 45.0877 35.116 46.0941C35.6855 46.3286 36.3145 46.3286 36.884 46.0941C39.3285 45.0877 46 41.676 46 34.417Z",
    fill: "#CCB7FF"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M46 36.3943H41.2502L39.9881 33.5361C39.8278 33.173 39.4599 32.9375 39.0528 32.9375C38.6457 32.9375 38.2778 33.173 38.1175 33.5361L36 38.3315L35.4089 36.9929C35.2486 36.6297 34.8807 36.3943 34.4736 36.3943H26C26.128 37.0947 26.3218 37.7526 26.5676 38.3696H33.8026L35.0647 41.2278C35.225 41.5909 35.5929 41.8264 36 41.8264C36.4071 41.8264 36.775 41.5909 36.9353 41.2278L39.0528 36.4324L39.6439 37.771C39.8042 38.1341 40.1721 38.3696 40.5792 38.3696H45.4324C45.6782 37.7526 45.872 37.0947 46 36.3943Z",
    fill: "#22003C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTatvaAiDdx);
export default __webpack_public_path__ + "static/media/tatva-ai-ddx.70dacd6e8f57b300ddf309293d2deddc.svg";
export { ForwardRef as ReactComponent };